import { render } from "./comment-teleport.vue?vue&type=template&id=935cb8fe&scoped=true&ts=true"
import script from "./comment-teleport.vue?vue&type=script&lang=ts"
export * from "./comment-teleport.vue?vue&type=script&lang=ts"

import "./comment-teleport.vue?vue&type=style&index=0&id=935cb8fe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935cb8fe"]])

export default __exports__